module.exports = __webpack_public_path__ + "img/01.28772179.jpg";